import type { Client, Osdk } from "@osdk/client";
import { QueryClient, useQuery, UseQueryResult } from "@tanstack/react-query";
import { ReportTheme } from "@unruly-osdk/sdk";

const keys = {
  all: ["report-themes"] as const,
  byReportId: (reportId: string) => [...keys.all, reportId] as const,
};

function ReportThemeService(_queryClient: QueryClient, apiClient: Client) {
  const service = {
    useGetReportThemesByReportId: (
      reportId: string,
    ): UseQueryResult<Osdk.Instance<ReportTheme>[], unknown> => {
      return useQuery({
        queryKey: keys.byReportId(reportId),
        queryFn: async () => {
          try {
            const response = await apiClient(ReportTheme)
              .where({ report: reportId })
              .fetchPageWithErrors({
                $orderBy: { themeSequence: "asc" },
              });

            if (!response.error) {
              return response.value.data;
            } else {
              throw new Error("Data not found in response");
            }
          } catch (error) {
            console.error("Error fetching report themes:", error);
            throw error;
          }
        },
        enabled: !!reportId,
      });
    },
  };

  return service;
}

export default ReportThemeService;
